// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MBzsT","div":"Footer_div__RdhGk","skill":"Footer_skill__yaMMX","text":"Footer_text__V94hY"};